module.exports = __webpack_public_path__ + "img/bjx-charge-table.b5c84878.png";